import React, { useEffect } from "react";
import { connect } from "react-redux";
import ShippersComponent from "./ShippersComponent";
import { BrandsManagementsFunction } from "../../redux/index";
import { useParams } from "react-router";
import { EndPoints } from "../../utils/EndPoints";

function ShippersContainer(props) {
  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = () => {
    if (props.user.uid) {
      props.BrandsManagementsFunction("get", EndPoints["Shippers"]);
      props.BrandsManagementsFunction(
        "get",
        EndPoints["Beneficiarys"],
        null,
        EndPoints["Beneficiarys"],
        null,
        { is_active: "True" }
      );
    }
  };

  const { tab, id } = useParams();
  const params = { tab: tab, id: id };
  return <ShippersComponent {...props} params={params} />;
}

const mapStateToProps = (state) => ({
  user: state.authentication.user,
  [EndPoints["Shippers"]]: state.modules[EndPoints["Shippers"]],
  [EndPoints["Beneficiarys"]]: state.modules[EndPoints["Beneficiarys"]],
  loading: state.modules.loading,
});
const mapDispatchToProps = {
  BrandsManagementsFunction,
};

export default connect(mapStateToProps, mapDispatchToProps)(ShippersContainer);
